import React, { ReactNode } from 'react';
import { IconButton } from 'office-ui-fabric-react';

import { Props } from './PageHeader.types';
import { Styled } from './PageHeader.styles';
import { useHistory } from 'react-router';
import { createPortal } from 'react-dom';

export const PageHeader: React.FC<Props> = ({
  title,
  backPath,
  actionButton,
  backAction,
  iconName = 'Back',
  primaryButtonNode,
  pinToTop,
  ...props
}) => {
  const history = useHistory();

  const onBack =
    backAction ||
    (() => (backPath ? history.push(backPath) : history.goBack()));

  let primaryButton: ReactNode = null;
  if (iconName) {
    primaryButton = (
      <IconButton
        iconProps={{
          iconName,
        }}
        onClick={onBack}
      />
    );
  }

  if (primaryButtonNode !== undefined) {
    primaryButton = primaryButtonNode;
  }

  const element = (
    <Styled.Header {...props}>
      {primaryButton}
      {title && <h1>{title}</h1>}
      {actionButton}
    </Styled.Header>
  );
  if (pinToTop) {
    return createPortal(element, document.body);
  }
  return element;
};
